import React, {Component} from 'react'
import IAASpeed from "./IAASpeed"
import IAAAvailableAccounts from "./IAAAvailableAccounts"
import IAAMinimumAccounts from "./IAAMinimumAccounts"
import IAATotalProcesses from "./IAATotalProcesses"
import IAATotalJobs from "./IAATotalJobs"

class IAAStatistics extends Component {
    render() {
        return (
            <div className="IAAStatistics col-md-4 col-12">
                <h4>Info and Ads statistics</h4>
                <IAAMinimumAccounts/>
                <IAAAvailableAccounts/>
                <IAASpeed/>
                <IAATotalProcesses/>
                <IAATotalJobs/>
            </div>
        )
    }
}


export default IAAStatistics



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/iaa/IAAStatistics.js